import type { ISerialize } from '@/objects/ISerialize';

export class SeriesSelectLine implements ISerialize {
    public text: string;

    public value: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { text?: string | null; value?: number }) {
        this.text = values.text ?? '';

        this.value = values.value ?? 0;
    }

    public serialize(): string {
        return '{' + `"text": ${JSON.stringify(this.text)}` + ',' + `"value": ${JSON.stringify(this.value)}` + '}';
    }

    /**
     * Creates an instance of SeriesSelectLine from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { text?: string | null; value?: number }): SeriesSelectLine {
        return new SeriesSelectLine(values);
    }

    public static _FromServerJson(json: any): SeriesSelectLine {
        return new SeriesSelectLine({ text: json.text ?? '', value: json.value });
    }

    /**
     * Creates an instance of SeriesSelectLine from another instance of SeriesSelectLine.
     * @param other The SeriesSelectLine you want to clone
     * @returns A cloned SeriesSelectLine
     */
    public static FromOther(other: SeriesSelectLine): SeriesSelectLine {
        return SeriesSelectLine._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return SeriesSelectLine.FromOther(this);
    }

    static NAME_OF_CLASS = 'SeriesSelectLine';
}
